import { render, staticRenderFns } from "./StateChip.vue?vue&type=template&id=b8a919c8&scoped=true"
import script from "./StateChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./StateChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StateChip.vue?vue&type=style&index=0&id=b8a919c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a919c8",
  null
  
)

export default component.exports